import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-checkboxes-radios',
    imports: [RouterLink],
    templateUrl: './checkboxes-radios.component.html',
    styleUrl: './checkboxes-radios.component.scss'
})
export class CheckboxesRadiosComponent {}